import { SummaryTableList } from './types'
import { marketAccounts } from './constants'
import CHANNELS from '../../../constants/Channels'

export function sortDataBySortKey(list: any, sortHeader: string, sortDirection: string): SummaryTableList[] {
  if (list === undefined) return []
  if (!sortHeader || !sortDirection) return list

  let accessor
  switch (sortHeader) {
    case 'sequence':
      accessor = reviewListItem => reviewListItem.sequence.toString()
      break
    case 'SKU':
      accessor = reviewListItem => reviewListItem.sku
      break
    case 'Username':
      accessor = reviewListItem => reviewListItem.user.name
      break
    case 'Status':
      accessor = reviewListItem => reviewListItem.state
      break
    default:
      return list
  }

  return list.sort((a, b) => {
    // This handles null values. If the `accessor` function returns null,
    // returning -1 or 1, depending on the sort direction.
    if (!accessor(a)) {
      return sortDirection === 'asc' ? -1 : 1
    }
    if (!accessor(b)) {
      return sortDirection === 'asc' ? 1 : -1
    }

    if (sortDirection === 'asc') {
      return accessor(a).localeCompare(accessor(b), undefined, { numeric: true })
    }
    return accessor(b).localeCompare(accessor(a), undefined, { numeric: true })
  })
}

// @param list The data to be sorted.
// @param sortingOrder The order in which the data should be sorted.
export function sortDataBySortOrder(list: SummaryTableList[], sortingOrder: number[]): SummaryTableList[] {
  if (list === undefined) return []
  if (!sortingOrder) return list

  return list.sort((a, b) => {
    return sortingOrder.indexOf(a.id) - sortingOrder.indexOf(b.id)
  })
}

export function getMarketId(marketName: string): number {
  switch (marketName) {
    case marketAccounts.EBAY:
      return CHANNELS.EBAY.id
    case marketAccounts.SHOPGOODWILL:
      return CHANNELS.SHOPGOODWILL.id
    case marketAccounts.SHOPIFY:
      return CHANNELS.SHOPIFY.id
    case marketAccounts.DEPOP:
      return CHANNELS.DEPOP.id
    default:
      return null
  }
}

// This method updates the given list of data by adding a `sequence` property to each item.
// @param list The list of data to update.
export function addSequenceToData(list: SummaryTableList[]): SummaryTableList[] {
  if (list === undefined) return []

  const newList = list.map((item, key) => {
    return {
      ...item,
      sequence: key + 1
    }
  })
  return newList
}
